import React from 'react';
import { ReactComponent as ArrowLeft } from './icons/arrow_left.svg';
import { ReactComponent as ArrowRight } from './icons/arrow_right.svg';
import * as Styled from './BannersStyled';
import { useClickStreamContext } from '../ClickStream';
import BannerInner from './BannerInnerUI';
import { BannersProps } from './BannerModel';

const BannerUI = ({ items, currentIndex, prevIndex, animateType, ...props }: BannersProps) => {
	const {
		logPageEvent = () => {
			//nothing
		},
	} = useClickStreamContext();

	if (!items.length) {
		return null;
	}

	return (
		<Styled.Wrap onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave}>
			<Styled.Banner>
				{items &&
					items.map((el, i) => (
						<BannerInner
							key={'banner' + i}
							{...el}
							animateType={animateType}
							isPrev={prevIndex === i}
							isCurrent={currentIndex === i}
							logPageEvent={logPageEvent}
						/>
					))}
				<Styled.Arrows Show={props.showArrow}>
					{currentIndex !== 0 && (
						<Styled.Arrow Left onClick={props.onClickLeft}>
							<ArrowLeft />
						</Styled.Arrow>
					)}
					{currentIndex !== items.length - 1 && (
						<Styled.Arrow Right onClick={props.onClickRight}>
							<ArrowRight />
						</Styled.Arrow>
					)}
				</Styled.Arrows>
			</Styled.Banner>
			<Styled.Control>
				{items && items.length > 1
					? items.map((el, i) => (
							<Styled.Point
								data-point-index={i}
								key={'point' + i}
								onClick={props.onClickPoint}
								isCurrent={currentIndex === i}
							/>
					  ))
					: null}
			</Styled.Control>
		</Styled.Wrap>
	);
};

export default BannerUI;
